// extracted by mini-css-extract-plugin
export default {"list":"unorderList_list__oZsVQ","listItem":"unorderList_listItem__e6Scq"};